import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IconMenu2, IconX } from "@tabler/icons-react";
import logoimg from "../../../assets/img/icon.png";

function HomeNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigationLinks = [
    { href: "/#hero", text: "INICIO" },
    { href: "/#about", text: "NOSOTROS" },
    { href: "/#how-it-works", text: "CÓMO FUNCIONA" },
    { href: "/#restaurants", text: "RESTAURANTES" },
    { href: "/#contact", text: "CONTACTO" },
  ];

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const closeMenu = () => setIsMenuOpen(false);

  // (Opcional) Cierra con ESC y bloquea scroll cuando el menú está abierto
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && closeMenu();
    document.addEventListener("keydown", onKey);
    if (isMenuOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <nav className="bg-white shadow-lg border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-3">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center rounded-full">
              <img
                src={logoimg}
                className="w-10 transition-transform hover:scale-105 rounded-full"
                alt="TableChat Logo"
              />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-1">
            {navigationLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="px-4 py-2 text-gray-700 hover:text-[#ff1049] hover:bg-gray-50 rounded-md transition-all duration-200 font-medium text-sm"
              >
                {link.text}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMenu}
              aria-expanded={isMenuOpen}
              aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
              className="p-2 rounded-md text-[#ff1049] hover:bg-gray-100 transition-colors duration-200"
            >
              {isMenuOpen ? <IconX size={24} /> : <IconMenu2 size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Backdrop (clic para cerrar) */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={closeMenu}
        />
      )}

      {/* Mobile Overlay Menu (por encima) */}
      <div
        className={`fixed top-0 left-0 right-0 z-50 lg:hidden transform transition-transform duration-300 ${
          isMenuOpen ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="bg-white shadow-xl">
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
           <div></div>
            <button
              onClick={closeMenu}
              aria-label="Cerrar menú"
              className="p-2 rounded-md text-gray-700 hover:text-[#ff1049] hover:bg-gray-100 transition-colors"
            >
              <IconX size={24} />
            </button>
          </div>

          {/* Lista de enlaces */}
                   <div className="px-4 py-2">
                        
            {navigationLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="block px-2 py-3 text-gray-800 hover:text-[#ff1049] hover:bg-gray-50 rounded-md transition-all font-medium"
                onClick={closeMenu}
              >
                {link.text}
              </a>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default HomeNavbar;
